import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';

export interface DocumentRequestFile {
  uuid: string;
  name: string;
}

export interface DocumentRequestTemplateJson {
  id: number;
  module_type: DocumentRequestModuleType;
  title: string;
  description: string;
  sample_file: DocumentRequestFile;
}

export class DocumentRequestTemplate {
  constructor(
    public id: number,
    public moduleType: DocumentRequestModuleType,
    public title: string,
    public description: string,
    public sampleFile: DocumentRequestFile
  ) {}

  static fromJson(json: Partial<DocumentRequestTemplateJson>): DocumentRequestTemplate {
    return new DocumentRequestTemplate(json.id, json.module_type, json.title, json.description, json.sample_file);
  }
}
